// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_t-p","cls2":"CiterightLanding-cls2_CBg CiterightLanding-cls1_t-p"};